import {ProviderListItem} from '../../../integrated-client/models/';

interface ITableData {
  records: Array<ProviderListItem>
}

export class TableData implements ITableData{
  records: Array<ProviderListItem>
 
  constructor() {
    this.records = [];
  }

}
